import React from 'react';
import { useTranslations } from '@lang';
import { BasketRoomExtra } from 'shared-types/Room';
import { Price } from '../../../../Price/Price';
import { ExtraContainer, ExtraPrice, ExtraText } from './RoomExtra.styles';

type RoomExtraProps = {
  roomExtra: BasketRoomExtra;
};

export const RoomExtra: React.FC<RoomExtraProps> = ({ roomExtra: { name, quantity, price } }) => {
  const { t } = useTranslations();
  return (
    <ExtraContainer>
      <ExtraText>
        {name} x {quantity}
      </ExtraText>
      <ExtraPrice>
        {price && price?.amount > 0 ? <Price price={price} /> : t('room.extras.complimentary')}
      </ExtraPrice>
    </ExtraContainer>
  );
};
